import { createElement } from 'react';
import PropTypes from 'prop-types';
import { map as _map } from 'lodash';
import moment from 'moment';
import utils from '../utils';
import './style.scss';
import { jsx as _jsx } from "react/jsx-runtime";

var MonthsLabel = function MonthsLabel(props) {
  var period = props.period,
      getX = props.getX,
      height = props.height,
      vertical = props.vertical,
      dayWidth = props.dayWidth;
  var periodStart = moment(period.start);
  var periodEnd = moment(period.end);
  var monthsCfg = utils.interval.getMonths(periodStart, periodEnd);
  var className = 'ptr-timeline-month-label';

  if (dayWidth > 30) {
    className = "".concat(className, " large");
  }

  var months = _map(monthsCfg, function (month) {
    if (month.month !== '01') {
      var labelXCorrection = -3;
      var x = getX(month.start) + labelXCorrection;
      var label = /*#__PURE__*/createElement(utils.textLabel["default"], {
        label: month.month,
        vertical: vertical,
        x: x,
        height: height,
        className: className
      });
      return /*#__PURE__*/_jsx("g", {
        className: 'ptr-timeline-month',
        children: label
      }, "".concat(month.year, "-").concat(month.month));
    } else {
      return null;
    }
  });

  return /*#__PURE__*/_jsx("g", {
    className: 'levels',
    children: months
  });
};

MonthsLabel.propTypes = {
  period: PropTypes.shape({
    start: PropTypes.string,
    end: PropTypes.string
  }).isRequired,
  getX: PropTypes.func.isRequired,
  dayWidth: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  vertical: PropTypes.bool
};
MonthsLabel.defaultProps = {
  vertical: false
};
export default MonthsLabel;